export enum EFilterKeys {
  GUID = 'guids',
  Sender = 'sender_ids',
  Receiver = 'receiver_ids',
  Status = 'statuses',
  Participant = 'participant',
  AmountMin = 'min_amount',
  AmountMax = 'max_amount',
  CreatedAt = 'created_at',
  SenderCounterparty = 'sender_counterparty',
  SenderType = 'sender_type',
  SenderBranch = 'sender_branch',
  RecipientBranch = 'receiver_branch',
  RecipientType = 'recipient_type',
  RecipientCounterparty = 'receiver_counterparty',
  Asset = 'asset',
  Search = 'search',
  
}

export enum EOperationParticipant {
  Sender = 'sender',
  Recipient = 'recipient',
  AllAnd = 'allAnd',
  AllOr = 'allOr',
}

export enum ReportingPaymentsGetParams {
  ModalPaymentInformationGUID = 'modalPaymentInformationGUID'
}
